import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './css/common.css';
import './css/statusicons.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { AdminLayout } from './views/admin/layouts/AdminLayout';
import { GuestLayout } from './views/guest/layouts/GuestLayout';

//管理画面orゲスト画面判定
const path = window.location.pathname.slice(1); //パスパラメータを先頭の/を除いて取得
const params = path.split("/");
let kbn = "";
if (params.length > 1){
  kbn = params[1];
}

if (kbn === "admin") {
  //管理画面
  ReactDOM.render(
    <React.StrictMode>
      <AdminLayout/>
    </React.StrictMode>,
    document.getElementById('root')
  );
} else {
  //ゲスト画面
  ReactDOM.render(
    <React.StrictMode>
      <GuestLayout/>
    </React.StrictMode>,
    document.getElementById('root')
  );
}